/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Avatar, Icon } from '@components/atoms'

import { blue, blueGrey } from '@mui/material/colors'

import { UserType } from '@schemas'

interface PropsType {
	user: UserType
	isChecked?: boolean
	showDepartmentName?: boolean
	style?: React.CSSProperties
	className?: string
	icon?: JSX.Element
}

export const ListUserInfo = (props: PropsType) => {
	const { user } = props
	const isChecked: boolean = props.isChecked ?? false
	const showDepartmentName: boolean = props.showDepartmentName ?? false

	return (
		<View
			css={[style, { ...props.style }]}
			className={props.className ? props.className : ''}
		>
			<View className="userInnerView">
				{isChecked ? (
					<View className="checkView">
						<Icon name="check-bold" className="check" />
					</View>
				) : (
					<Avatar
						className="userInfoAvatar"
						picture={user.profileImageUrl}
						name={user.name}
						color={user.profileColor === '' ? blueGrey[100] : user.profileColor}
						icon={props.icon}
					/>
				)}

				<View className="textView">
					<View className="nameView">
						<Text category="p2" className="name">
							{user.name}
						</Text>
					</View>
				</View>
			</View>
		</View>
	)
}

const style = css({
	width: '100%',

	'.userInnerView': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',

		'.userInfoAvatar': {
			marginRight: '0.5rem',
			width: '2.3rem',
			height: '2.3rem',
		},

		'.textView': {
			'.nameView': {
				display: 'flex',
				alignItems: 'center',

				'.name': {
					margin: 0,
				},

				'.title': {
					margin: 0,
					marginLeft: '0.5rem',
				},
			},

			'.departmentName': {
				margin: 0,
				marginTop: '0.3rem',
				fontSize: '10px',
			},
		},

		'.checkView': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '2.3rem',
			height: '2.3rem',
			marginRight: '0.5rem',
			background: blue['A400'],
			borderRadius: '50%',

			'.check': {
				color: 'white',
			},
		},
	},
})
